import { render, staticRenderFns } from "./TheoryPracticeLesson.vue?vue&type=template&id=1b932ae5&scoped=true&"
import script from "./TheoryPracticeLesson.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeLesson.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeLesson.vue?vue&type=style&index=0&id=1b932ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b932ae5",
  null
  
)

export default component.exports